import { TransportationAttribute } from "@/data/models/transportation-attribute.model";

enum AttributeControlType {
  CHECKBOX,
  DROPDOWN,
}

type SecondaryAttribute = {
  id: string;
  name: string;
  controlType: AttributeControlType;
  listOptions?: TransportationAttribute[];
  displayOrder: number;
}

export { AttributeControlType };
export type { SecondaryAttribute };